import React from 'react';

// import Devops from '../assets/images/tools/Devops.webp';
// import JSON from '../assets/images/tools/JSON.webp';
// import Jenkins from '../assets/images/tools/Jenkins.webp';
// import Laravel from '../assets/images/tools/Laravel.webp';
// import NetMVC from '../assets/images/tools/Net-MVC.webp';
// import php from '../assets/images/tools/Php.webp';
// import postgreSQL from '../assets/images/tools/PostgreSQL.webp';
// import sqlserve from '../assets/images/tools/SQL-serve-Reporting-serve.webp';
// import ajax from '../assets/images/tools/ajax.webp';
// import amazon from '../assets/images/tools/amazon-db.webp';
// import aspdotnet from '../assets/images/tools/asp.net-webform.webp';
// import azure from '../assets/images/tools/azure.webp';
// import boilerplate from '../assets/images/tools/boilerplate.webp';
// import csharp from '../assets/images/tools/c-sharp.webp';
// import cordova from '../assets/images/tools/cordova.webp';
// import cypruss from '../assets/images/tools/cypruss.webp';
// import indesign from '../assets/images/tools/indesign.webp';
// import invision from '../assets/images/tools/invision.webp';
// import ionic from '../assets/images/tools/ionic.webp';
// import jquery from '../assets/images/tools/jquery.webp';
// import less from '../assets/images/tools/less.webp';
// import manodb from '../assets/images/tools/mano-db.webp';
// import polymer from '../assets/images/tools/polymer.webp';
// import semantic from '../assets/images/tools/semantic.webp';
// import sketch from '../assets/images/tools/sketch.webp';
// import sqllittle from '../assets/images/tools/sql-lite.webp';




import { Navigation, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

export default function ToolsSlider() {
  return (
    
    

<section className='tools_we_use_section mt-5 mb-5'>

<div className='container'>

<div className='row'>

    <div className='col-12 text-center mt-2'><h5>Tools & Technologies We use for Offshore Software Development </h5></div>

    <div className='col-12 mt-5 text-center'>
    <Swiper
      // install Swiper modules
      modules={[Navigation, Autoplay]}
    //spaceBetween={40}
      navigation

      autoplay={{
        delay: 6000,
        disableOnInteraction: false,
      }}

      breakpoints={{ 

        1200: {
          slidesPerView: 4,
        },
      }}


    >


      <SwiperSlide>     
        <div className='tools_using'>
          <h6>Frontend</h6>
          <ul>
            <li>HTML/CSS</li>
            <li>Angular Js</li>
            <li>React Js</li>
            <li>Vue Js</li>
          </ul>         
          </div>     
      </SwiperSlide>

      <SwiperSlide>     
        <div className='tools_using'>
          <h6>BackEnd</h6>
          <ul>
            <li>.NET</li>
            <li>Java</li>
            <li>Python</li>
            <li>Node.Js</li>
          </ul>         
          </div>     
      </SwiperSlide>


      <SwiperSlide>     
        <div className='tools_using'>
          <h6>BackEnd</h6>
          <ul>
            <li>C/C++</li>
            <li>Django</li>
            <li>Golang</li>
            <li>PHP</li>
          </ul>         
          </div>     
      </SwiperSlide>


      <SwiperSlide>     
        <div className='tools_using'>
          <h6>Mobility</h6>
          <ul>
            <li>Android/Kotlin</li>
            <li>iOS/Swift</li>
            <li>React Native</li>
            <li>Flutter</li>
          </ul>         
          </div>     
      </SwiperSlide>


      <SwiperSlide>     
        <div className='tools_using'>
          <h6>Blockchain</h6>
          <ul>
            <li>Solidity</li>
            <li>Ethereum</li>
            <li>Hyperledger</li>
            <li>Smart Contract</li>
          </ul>         
          </div>     
      </SwiperSlide>


      <SwiperSlide>     
        <div className='tools_using'>
          <h6>Full Stack</h6>
          <ul>
            <li>MEAN</li>
            <li>MERN</li>
            <li>JavaScript</li>
            <li>Python</li>
          </ul>         
          </div>     
      </SwiperSlide>


      <SwiperSlide>     
        <div className='tools_using'>
          <h6>DevOps & ML</h6>
          <ul>
            <li>Azure</li>
            <li>AWS</li>
            <li>TensorFlow</li>
            <li>Dialogflow</li>
          </ul>         
          </div>     
      </SwiperSlide>


   
      {/* <SwiperSlide><div className='box'><img src={sqllittle} alt=''></img></div></SwiperSlide> */}

    </Swiper>

    </div>
    </div>

</div>




</section>


  )
}
